import { action, createRequestTypes } from 'utils/ReduxHelpers'

import { GET, POST } from 'utils/Constants'
import { IDiscourseCategory, INotification } from 'core/models/Models'
import { JsonValue } from 'react-use-websocket/dist/lib/types'

export const NOTIFICATIONS = createRequestTypes('NOTIFICATIONS', [GET, POST])
export const NOTIFICATIONS_COUNT = createRequestTypes('NOTIFICATIONS_COUNT', [GET])
export const DISCOURSE_CATEGORIES = createRequestTypes('DISCOURSE_CATEGORIES', [GET, POST])
export const ADD_NEW_NOTIFICATION = 'ADD_NEW_NOTIFICATION'

export const getDiscourseUserNotifications = {
  request: (userId: number, offset = 0, limit = 10, append = false) =>
    action(NOTIFICATIONS.GET.REQUEST, { userId, offset, limit, append }),
  success: (payload: any) => action(NOTIFICATIONS.GET.SUCCESS, payload),
  failure: (error: string) => action(NOTIFICATIONS.GET.FAILURE, error),
}

export const getDiscourseUserCategories = {
  request: (userId: number) => action(DISCOURSE_CATEGORIES.GET.REQUEST, { userId }),
  success: (payload: Array<IDiscourseCategory>) => action(DISCOURSE_CATEGORIES.GET.SUCCESS, payload),
  failure: (error: string) => action(DISCOURSE_CATEGORIES.GET.FAILURE, error),
}

export const updateDiscourseUserCategories = {
  request: (categories: IDiscourseCategory[], discourseUsername: string) =>
    action(DISCOURSE_CATEGORIES.POST.REQUEST, { categories, discourseUsername }),
  success: (categories: IDiscourseCategory[]) => action(DISCOURSE_CATEGORIES.POST.SUCCESS, categories),
  failure: (error: any) => action(DISCOURSE_CATEGORIES.POST.FAILURE, error),
}

export const getUnreadNotificationsCount = {
  request: (userId: number) => action(NOTIFICATIONS_COUNT.GET.REQUEST, { userId }),
  success: (unreadNotificationsCount: number) =>
    action(NOTIFICATIONS_COUNT.GET.SUCCESS, { unreadNotificationsCount }),
  failure: (error: string) => action(NOTIFICATIONS_COUNT.GET.FAILURE, error),
}

export const markAllUsersNotificationsAsRead = {
  request: (userId: number) => action(NOTIFICATIONS.POST.REQUEST, { userId }),
  success: () => action(NOTIFICATIONS.POST.SUCCESS),
  failure: (error: string) => action(NOTIFICATIONS.POST.FAILURE, error),
}

export const addNewNotification = (notification: INotification | JsonValue) =>
  action(ADD_NEW_NOTIFICATION, notification)
